import { memo, useCallback, useEffect, useRef, useState } from 'react'

import {
  CampaignOutlined,
  CheckOutlined,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
} from '@mui/icons-material'

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'

import Announcement from '../Announcement'
import { useUnreadAnnouncements } from '../../hooks'

import { Stepper, StepperButton } from './AnnouncementsDialog.styles'

const AnnouncementsDialog: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>()

  const [selectedAnnouncementIndex, setSelectedAnnouncementIndex] = useState(0)

  const { isSubmitInProgress, hasUnviewedAnnouncements, announcements, onMarkAsRead } = useUnreadAnnouncements()

  useEffect(() => {
    contentRef.current?.scrollTo({ top: 0, behavior: 'instant' })
  }, [selectedAnnouncementIndex])

  const onNext = useCallback(() => {
    setSelectedAnnouncementIndex((prevIndex) => prevIndex + 1)
  }, [])

  const onBack = useCallback(() => {
    setSelectedAnnouncementIndex((prevIndex) => prevIndex - 1)
  }, [])

  if (announcements.length === 0) {
    return null
  }

  const last = selectedAnnouncementIndex === announcements.length - 1

  return (
    <Dialog
      open={hasUnviewedAnnouncements}
      fullWidth
      maxWidth='md'
      PaperProps={{ sx: { height: '100%' } }}
      TransitionProps={{ unmountOnExit: true }}
    >
      <DialogTitle display='flex' alignItems='center'>
        Announcements <CampaignOutlined sx={{ ml: 1 }} />
      </DialogTitle>
      <DialogContent ref={contentRef}>
        <Announcement announcement={announcements[selectedAnnouncementIndex]} />
      </DialogContent>
      <DialogActions>
        <Stepper
          variant='dots'
          position='static'
          steps={announcements.length}
          activeStep={selectedAnnouncementIndex}
          backButton={
            <StepperButton
              size='small'
              variant='outlined'
              onClick={onBack}
              disabled={isSubmitInProgress || selectedAnnouncementIndex <= 0}
              startIcon={<KeyboardArrowLeftOutlined />}
            >
              Back
            </StepperButton>
          }
          nextButton={
            <StepperButton
              size='small'
              color='primary'
              variant='outlined'
              onClick={last ? () => onMarkAsRead() : onNext}
              disabled={isSubmitInProgress}
              endIcon={last ? <CheckOutlined /> : <KeyboardArrowRightOutlined />}
            >
              {last ? 'Got it' : 'Next'}
            </StepperButton>
          }
        />
      </DialogActions>
    </Dialog>
  )
}

AnnouncementsDialog.propTypes = {}

export default memo(AnnouncementsDialog)

